(function ($) {
    var cfg = window.pzCheckout || {};

    function digits(value) {
        var n = parseFloat(String(value || "").replace(/\s/g, "").replace(",", "."));
        return isNaN(n) ? 0 : n;
    }

    function money(value) {
        var parts = (Math.round(value * 100) / 100).toFixed(2).split(".");
        var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return parts[1] === "00" ? whole : whole + "," + parts[1];
    }

    var startedSent = false;
    function started(source) {
        if (startedSent || !cfg.iuteStartedUrl) return;
        startedSent = true;
        $.post(cfg.iuteStartedUrl, { adId: cfg.adId, source: source });
    }

    function showErrors($scope, errors) {
        $scope.find(".has-error").removeClass("has-error");
        $.each(errors, function (field, message) {
            var $field = $scope.find('[data-field="' + field + '"]');
            $field.addClass("has-error").find(".validation").addBack(".validation").first().text(message);
            $field.closest(".hidden").removeClass("hidden");
        });
        var $first = $scope.find(".has-error").first();
        if ($first.length) {
            $first[0].scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }

    var $calc = $("#iute-calculator");
    var loan = null;
    var timer = null;
    var amountTouched = false;
    var syncing = false;
    var allowedMonths = String($calc.data("months") || "").split(",").map(Number).filter(Boolean);

    function itemPrice() {
        return cfg.offer > 0 ? cfg.offer : digits(cfg.price);
    }

    function totalDue() {
        return itemPrice() + digits(cfg.deliveryFee);
    }

    function syncTabs() {
        var months = Number($("#iute-months-value").val());
        $calc.find(".tab").each(function () {
            var tabMonths = $(this).data("months");
            $(this).toggleClass("active", !amountTouched && (!tabMonths || tabMonths === months));
        });
    }

    function isIuteSelected() {
        return $("#checkout-payment-method").val() === String(cfg.iutePaymentMethod);
    }

    function nearestMonths(value) {
        return allowedMonths.reduce(function (best, m) {
            return Math.abs(m - value) < Math.abs(best - value) ? m : best;
        }, allowedMonths[0]);
    }

    function syncAmount() {
        if (amountTouched) return;
        syncing = true;
        $("#iute-amount").val(loan.Amount)[0].dispatchEvent(new Event("input", { bubbles: true }));
        syncing = false;
    }

    function render() {
        if (!loan || !loan.IsAvailable) return;
        syncAmount();
        $(".iute-monthly").text(money(loan.MonthlyPayment));
        $(".iute-loan-amount").text(money(loan.Amount));
        $(".iute-loan-months").text(loan.Months);
        $(".iute-interest").text(loan.InterestRate);
        $(".iute-eir").text(loan.EffectiveInterestRate);
        $(".iute-access-fee").text(money(loan.AccessFee));
        $(".iute-total-repay").text(money(loan.TotalToRepay));
        $(".iute-full-amount").text(money(loan.Amount));
        $(".iute-financed-amount").text(money(loan.Amount));
        if (loan.Remaining !== null) {
            $(".iute-remaining-amount").text(money(loan.Remaining));
            $calc.find(".iute-full").toggleClass("hidden", !loan.CoversPrice || loan.BelowMin);
            $calc.find(".iute-min").toggleClass("hidden", !loan.BelowMin);
            $calc.find(".iute-partial").toggleClass("hidden", loan.CoversPrice);
            $calc.find(".iute-max-note").toggleClass("hidden", !loan.AboveMax);
            $(".iute-total-remaining").toggleClass("hidden", loan.CoversPrice || !isIuteSelected());
        }
    }

    function refresh() {
        if (!$calc.length || !cfg.iuteLoanOptionsUrl) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
            $.get(cfg.iuteLoanOptionsUrl, {
                adId: cfg.adId,
                price: cfg.placeOrderUrl ? totalDue() : $calc.data("price"),
                amount: amountTouched ? digits($("#iute-amount").val()) : "",
                months: $("#iute-months-value").val(),
                currency: $("input[name=OfferCurrency]").val()
            }).done(function (data) { loan = data; render(); });
        }, 250);
    }

    function submit(url, data, $btns, handle) {
        var fail = function () {
            $btns.prop("disabled", false).removeClass("active");
            $("#iute-error-trigger")[0].click();
        };
        $.post(url, data)
            .done(function (res) {
                if (res && res.success === false) {
                    fail();
                    return;
                }
                $btns.prop("disabled", false).removeClass("active");
                handle(res);
            })
            .fail(fail);
    }

    function setMonths(months) {
        $("#iute-months-value").val(months);
        var slider = $calc.find(".iute-months-slider")[0];
        if (slider) {
            slider.value = months;
            slider.dispatchEvent(new Event("input", { bubbles: true }));
        }
        var select = $calc.find(".iute-months-select")[0];
        if (select && typeof select.setValue === "function") {
            select.setValue([String(months)]);
        }
    }

    if ($calc.length) {
        $calc.on("click", ".tab", function () {
            amountTouched = false;
            $calc.removeClass("collapsed");
            if ($(this).data("months")) {
                setMonths($(this).data("months"));
            }
            syncTabs();
            refresh();
        });
        $calc.on("input", "#iute-amount", function () {
            if (syncing || !loan || digits(this.value) === loan.Amount) return;
            amountTouched = true;
            syncTabs();
            refresh();
        });
        $calc.on("input", ".iute-months-slider", function () {
            var months = nearestMonths(Number(this.value));
            $("#iute-months-value").val(months);
            syncTabs();
            refresh();
        });
        $calc.on("change", ".iute-months-slider", function () {
            setMonths(nearestMonths(Number(this.value)));
        });
        $calc.find(".iute-months-select").on("select-change", function (e) {
            var value = e.originalEvent && e.originalEvent.detail ? e.originalEvent.detail.values[0] : null;
            if (value) {
                $("#iute-months-value").val(value);
                syncTabs();
                refresh();
            }
        });
        refresh();
    }

    $(document).on("click", '[data-dropup-modal-target="#modal-iute-step-2"]', function () {
        started(2);
    });

    $(document).on("click", ".iute-apply-submit", function () {
        var $form = $("#iute-apply-form");
        var $btn = $(this).prop("disabled", true).addClass("active");
        var data = $form.serialize() + "&IuteAmount=" + digits($("#iute-amount").val()) + "&IuteMonths=" + $("#iute-months-value").val();
        submit(cfg.iuteApplyUrl, data, $btn, function (res) {
            if (res && res.errors) {
                showErrors($form, res.errors);
                return;
            }
            $("#iute-step-3-trigger")[0].click();
        });
    });

    $(document).on("click", ".iute-buy-now", function () {
        var url = $(this).data("checkout-url");
        window.location.href = url + (url.indexOf("?") < 0 ? "?" : "&") + "payment=iute&months=" + $("#iute-months-value").val();
    });

    var $form = $("#checkout-form");
    if (!$form.length) return;

    $(".website-wrapper").addClass("ci-padding-b-0");

    function updateTotals() {
        $(".checkout-item-price").text(money(itemPrice()));
        $(".checkout-fee").text(money(digits(cfg.deliveryFee)));
        $(".checkout-total").text(money(totalDue()));
        if (isIuteSelected()) {
            refresh();
        }
    }

    function syncPhone() {
        var number = $(".checkout-phone-number").val().replace(/\D/g, "").replace(/^0+/, "");
        var code = $(".checkout-phone-code .selection-data").text().trim() || $("#select-country-code .option-item.active").data("select-option-value");
        $form.find("input[name=Phone]").val(number ? code + number : "");
    }

    $form.on("click", "[data-payment-method]", function () {
        var method = String($(this).data("payment-method"));
        var isIute = method === String(cfg.iutePaymentMethod);
        $("#checkout-payment-method").val(method);
        $(".iute-only").toggleClass("hidden", !isIute);
        $(".cash-only").toggleClass("hidden", isIute);
        if (loan) {
            render();
        }
        if (isIute) {
            started(1);
            refresh();
        }
    });

    $form.on("click", ".checkout-edit-info", function () {
        $(".checkout-info-fields").removeClass("hidden");
        $(".checkout-info-summary").addClass("hidden");
        $(this).addClass("hidden");
    });

    $form.on("click", ".checkout-new-address", function () {
        $(".checkout-address-fields").removeClass("hidden").find("input").val("");
        $(".checkout-address-summary").addClass("hidden");
        $(this).addClass("hidden");
    });

    function loadFee() {
        $.get(cfg.deliveryFeeUrl, { city: $form.find("input[name=City]").val(), currency: $("input[name=OfferCurrency]").val() }).done(function (fee) {
            cfg.deliveryFee = fee;
            updateTotals();
        });
    }

    $form.find(".checkout-city").on("select-change", function (e) {
        var city = e.originalEvent && e.originalEvent.detail ? e.originalEvent.detail.values[0] : "";
        $form.find("input[name=City]").val(city || "");
        loadFee();
    });

    $form.find(".checkout-offer-currency").on("select-change", function (e) {
        var display = e.originalEvent && e.originalEvent.detail ? e.originalEvent.detail.values[0] : "";
        if (!display) return;
        $(".checkout-currency").text(display);
        $form.find("input[name=OfferCurrency]").val($('#checkout-currencies .option-item[data-select-option-value="' + display + '"]').data("currency"));
        loadFee();
    });

    function showOffer(editing) {
        var offered = cfg.offer > 0;
        $(".checkout-price-btn").toggleClass("hidden", editing);
        $(".checkout-offer, .row-actual-price .currency").toggleClass("hidden", !editing);
        $(".checkout-price-btn .ci-pencil").toggleClass("hidden", offered);
        $(".checkout-price-btn .ci-cross").toggleClass("hidden", !offered);
        $(".row-old-price").toggleClass("hidden", !offered);
    }

    function setOffer(value) {
        cfg.offer = value;
        updateTotals();
    }

    $form.on("input", ".checkout-offer", function () {
        setOffer(digits(this.value));
    });

    $form.on("click", ".checkout-price-btn", function () {
        if (cfg.offer > 0) {
            $(".checkout-offer").val("");
            setOffer(0);
            showOffer(false);
            return;
        }
        showOffer(true);
        $(".checkout-offer").focus();
    });

    $form.on("blur", ".checkout-offer", function () {
        if (!$(".checkout-price-btn").length) return;
        if (cfg.offer === digits(cfg.price)) {
            this.value = "";
            setOffer(0);
        }
        showOffer(false);
    });

    $form.on("click", ".checkout-save", function () {
        var $btn = $(this);
        if (!cfg.saveAdUrl) {
            window.location = cfg.signInUrl + (cfg.signInUrl.indexOf("?") < 0 ? "?" : "&") + "returnUrl=" + encodeURIComponent(window.location.pathname + window.location.search);
            return;
        }
        $.get(cfg.saveAdUrl).done(function () { $btn.addClass("active"); });
    });

    $(document).on("click", ".checkout-submit", function () {
        var $btns = $(".checkout-submit").prop("disabled", true).addClass("active");
        syncPhone();
        submit(cfg.placeOrderUrl, $form.serialize(), $btns, function (res) {
            if (res && res.errors) {
                showErrors($form, res.errors);
                return;
            }
            $(".nav-footer-mobile.checkout").remove();
            $(".page-checkout").replaceWith(res);
            $(".page-order-success .format-money-int").each(function () {
                $(this).text(money(digits($(this).attr("value"))));
            });
            window.scrollTo(0, 0);
        });
    });

    if (cfg.preselectIute) {
        $form.find('[data-payment-method="' + cfg.iutePaymentMethod + '"]')[0].click();
    }
})(jQuery);
